<script>
    import {getContext, tick} from "svelte";
    import {asyncGenToStore} from "../../area-reports/requests";
    import {uuid} from "@manaakiwhenua/frag-svelte/src/uuid";
    import {updateReadyStore} from "@manaakiwhenua/frag-svelte/src/print-util/readyStore";
    import KeyValueTable from "../KeyValueTable.svelte";
    import {lucMap} from "../luc-map";

    export let request;

    const mapBaseUrl = getContext('mapBaseUrl');
    const wmsBaseUrl = getContext('wmsUrl');

    $: result = asyncGenToStore(request);

    function parseExtent(anExtent) {
        const numbers = anExtent.substring("BOX(".length, anExtent.length - 1)
        try {
            return numbers.split(/[, ]+/).map(parseFloat);
        } catch (e) {
            return undefined;
        }
    }

    function extentAndCode(data) {
        data = data || {};
        const {layers} = data.response || {};
        const {rows} = (layers || []).find(l => l.name === "lri_luc_extended") || {};
        const {columns} = (rows || [{columns: []}])[0];
        const nzcuColumn = columns.find(c => c.name === 'Dominant Land Use Capability Unit') || {};
        const extentColumn = columns.find(c => c.name === 'INTERNAL_Extent') || {};

        return {
            nzcu: nzcuColumn.value,
            extent: extentColumn.value
                ? parseExtent(extentColumn.value.value)
                : undefined
        }
    }

    const readyStore = getContext('readyStore')

    $: mapExtras = extentAndCode($result)
    $: extent = mapExtras.extent
    $: nzcu = mapExtras.nzcu

    const instanceId = uuid()

    let mapOptions

    updateReadyStore(readyStore, instanceId, false);

    $: {
        if ($result) {
            tick().then(() => {
                updateReadyStore(readyStore, instanceId, true);
            })
        }
    }

    $: {
        mapOptions = {mapBaseUrl, wmsBaseUrl, extent, nzcu, readyStore};
    }
</script>

{#if extent && nzcu}
    <KeyValueTable>
        <div class="report-attribute">
            <div class="report-attribute-title">NZLRI Unit Distribution (1:50,000)</div>
            <div class="report-attribute-value">
                <div class="lucMap" use:lucMap={mapOptions}></div>
            </div>
            <div class="report-attribute-description">
                Map showing the distribution of NZ Land Capability Unit {nzcu}
            </div>
        </div>
    </KeyValueTable>
{/if}

<style>
    .lucMap {
        width: 500px;
        height: 500px;
        background-color: #74ADCD !important;
    }

    @media print {
        .lucMap {
            height: 400px;
        }
    }

    th {
        vertical-align: top;
    }

    h4 {
        margin-left: 45px;
    }
</style>
